import React from 'react';
import { PropTypes } from 'prop-types';
import { useLabels, useSitemap } from 'wsm-common-data';
import { useAccountDetails } from '../features/accountDetails/accountDetailsSlice';

const ContactButtons = ({ phoneNumber, emailAddress }) => {
	const labels = useLabels();
	const accountId = useAccountDetails().id;
	const sitemap = useSitemap();

	const callLabel = labels.get('CALL');
	const messageLabel = labels.get('SEND_A_MESSAGE');

	return (
		<div
			className="location-ctas mb-3 d-flex pl-3"
			role="group"
			aria-label="Contact options"
		>
			{phoneNumber ? (
				<a
					href={`tel:${phoneNumber}`}
					className="btn btn-primary btn-small mr-4 d-flex align-items-center justify-content-center"
					aria-label={`${callLabel} ${phoneNumber}`}
					title={`${callLabel} ${phoneNumber}`}
					role="button"
				>
					<i
						className="ddc-icon ddc-icon-call ddc-icon-size-medium mr-2"
						aria-hidden="true"
					/>
					<span className="sr-only">Call phone number: </span>
					{callLabel}
				</a>
			) : null}
			<button
				className="btn btn-default btn-small d-flex align-items-center justify-content-center dialog"
				target="dialog"
				data-width="600"
				href={`${sitemap.get('CONTACT_FORM')}?accountId=${accountId}`}
				aria-label={`${messageLabel} ${emailAddress}`}
				title={`${messageLabel} ${emailAddress}`}
				type="button"
			>
				<i
					className="ddc-icon ddc-icon-email ddc-icon-size-medium mr-2"
					aria-hidden="true"
				/>
				<span className="sr-only">Send email to: </span>
				{messageLabel}
			</button>
		</div>
	);
};

ContactButtons.propTypes = {
	phoneNumber: PropTypes.string,
	emailAddress: PropTypes.string
};

export default ContactButtons;
